import './style.css'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react';
import { GetInformationAboutApplication } from '../../Redux/Reducers/ReportStage/InformationAboutApplication';
import { useSelector } from 'react-redux';
import InputAHSF from '../../Components/InputAHSF';
import { decryptToken } from '../../Services/Account/EncryptionParams';
import { useParams } from "react-router-dom"
const InformationAboutApplication = () => {
    const [appGuid, setAppGuid] = useState(null)
    const tokens = useParams().token
    const dispatch = useDispatch();
    const ApplicationInformation = useSelector((state) => state.REDInformationAboutApplication.InformationAboutApplicationInfo)
    useEffect(() => {


        if (tokens) {
            var token = decryptToken(tokens)
            setAppGuid(token)
            // console.log(token,"sdkjskijdsiiisd");

        }

    }, [])
    console.log(ApplicationInformation, "sdsdsdsd");

    useEffect(() => {


        dispatch(GetInformationAboutApplication({ aI_ApplicationInformationId: appGuid }))


    }, [appGuid])

    console.log(ApplicationInformation, "skljdsjkdjskjd");

    return (
        <>
            <div className='InformationAboutApplicationContainer'>
                <div className='hildIinf'>
                    <div className='childInformationAboutApplicationContainer'>
                        <InputAHSF
                            fieldsName="RS_ApplicantName"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.applicantName}
                        />
                        <InputAHSF
                            fieldsName="RS_Email"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.email}
                        />
                        <InputAHSF
                            fieldsName="RS_Phone"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.phoneNumber}
                        />
                        <InputAHSF
                            fieldsName="RS_nationality"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.nationality}
                        />
                    </div>
                    <div className='childInformationAboutApplicationContainer'>
                        <InputAHSF
                            fieldsName="RS_ProjectName"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.projectName}
                        />
                        <InputAHSF
                            fieldsName="RS_SupportProgram"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.supportProgram}
                        />
                        <InputAHSF
                            fieldsName="RS_MainSector"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.mainSector}
                        />
                        <InputAHSF
                            fieldsName="RS_BeneficiaryType"
                            show={true}
                            disabled={true}
                            value={ApplicationInformation?.applicantType}
                        />
                    </div>
                </div>

            </div>

        </>
    )
}

export default InformationAboutApplication